export default "__VITE_PUBLIC_ASSET__7b3645dc__"